export enum DeliveryNoteStatusEnum {
  new = 1,
  generated = 2,
  signed = 3,
  billed = 4,
}
